
<template>
  <div>
    <div class="box box-success">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t('search.title')}}</h3>
      </div>

      <div class="box-body">
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="input-group">
              <span class="input-group-addon"><i class="fa fa-car"></i></span>
              <input type="text" class="form-control" :placeholder="$t('common.code')" v-model="search.code">
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('apartment.title')" v-model="search.apartment">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.vehicle_owner')" v-model="search.vehicle_owner">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.vehicle_registration_name')" v-model="search.vehicle_registration_name">
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.vehicle_type')" v-model="search.vehicle_type">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.plate')" v-model="search.plate">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.branch')" v-model="search.branch">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.color')" v-model="search.color">
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.original_card')" v-model="search.original_card">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="input-group date">
              <div class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </div>
              <date-picker v-model="search.deactivate_card_date" :config="options" :placeholder="$t('vehicle.deactivate_card_date')"/>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <div class="input-group date">
              <div class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </div>
              <date-picker v-model="search.reactivate_card_date" :config="options" :placeholder="$t('vehicle.reactivate_card_date')"/>
            </div>
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle.issue_staff')" v-model="search.issue_staff">
          </div>
        </div>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-sm-3 col-md-3 col-lg-3">
            <input type="text" class="form-control" :placeholder="$t('vehicle_bicycle.applied_service')" v-model="search.applied_service">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
          </div>
          <div class="col-sm-3 col-md-3 col-lg-3">
            <button
              type="button"
              class="btn btn-labeled btn-success pull-right"
              @click="onSearchVehicle"
            >
              <span class="btn-label">
                <i class="glyphicon glyphicon-search"></i>
              </span>
              {{$t('search.search_button')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">Xe Máy Xe Hơi</h3>
      </div>

      <div class="box-body">
        <div class="row pull-right">
          <button 
            class="btn btn-info btn-sm extra-tools"
            @click="onOpenAddVehicle"
          >
            <i class="glyphicon glyphicon-plus"></i>
            Add
          </button>
          <!-- <div class="input-group input-group-sm" style="width: 150px;">
            <input type="text" name="table_search" class="form-control pull-right" placeholder="Search">
            <div class="input-group-btn">
              <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-sm-12 table-responsive no-padding">
            <b-table :items="vehicle_items" :fields="vehicle_fields" class="mt-3" outlined>
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template slot="applied_service" slot-scope="row">
                <span class="label label-success">{{row.item.applied_service}}</span>
              </template>
              <template slot="actions" slot-scope="row">
                <div class="btn-group">
                  <button 
                    class="btn btn-primary btn-sm" 
                    style="margin-left: 6px;"
                    @click="onOpenEditVehicle(row)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>  
                  </button>
                  <button
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px;"
                    @click="onOpenDeleteVehicle(row)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="row">
          <paginator
            :item="paginatorItem"
            @onpaginate="onPagination"
          />
        </div>
      </div>
    </div>
    <!-- Modal Bicycle Input -->
    <div class="modal fade" :ref="`modal-vehicle-input`">
      <div class="modal-dialog modal-lg">
        <vehicle-input
          :id="vehicle_data.id"
          @vehicle-add="onAddVehicle"
          @vehicle-save="onSaveVehicle"
        />
      </div>
    </div>
    <!-- Modal Confirm Delete -->
    <div class="modal fade" :ref="`modal-vehicle-delete`">
      <div class="modal-dialog">
        <confirm
          :id="vehicle_data.id"
          @confirm="onDeleteVehicle"
        />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import VehicleInput from './VehicleInput'
import LTECoreAlert from "@/components/LTESnackBar.vue"
import Confirm from "@/components/Confirm.vue"
import Paginator from "@/components/Paginator.vue"
import Loading from "vue-loading-overlay"
import datePicker from "vue-bootstrap-datetimepicker"
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css"
import utils from '@/lib/utils'

export default {
  name: "VehicleBikeCar",
  data() {
    return {
      vehicle_data: {
        id: 0
      },
      vehicle_fields: [
        { key: 'nonumber', label: 'common.nonumber', sortable: true, class: 'text-center' },
        { key: 'code', label: 'common.code', sortable: true, class: 'text-center' },
        { key: 'apartment', label: 'apartment.title', sortable: true, class: 'text-center' },
        { key: 'vehicle_owner', label: 'vehicle.vehicle_owner', sortable: true, class: 'text-center' },
        { key: 'vehicle_registration_name', label: 'vehicle.vehicle_registration_name', sortable: true, class: 'text-center' },
        { key: 'vehicle_type', label: 'vehicle.vehicle_type', sortable: true, class: 'text-center' },
        { key: 'plate', label: 'vehicle.plate', sortable: true, class: 'text-center' },
        { key: 'branch', label: 'vehicle.branch', sortable: true, class: 'text-center' },
        { key: 'color', label: 'vehicle.color', sortable: true, class: 'text-center' },
        // { key: 'isDriver', label: 'vehicle.isDriver', sortable: true, class: 'text-center' },
        { key: 'original_card', label: 'vehicle.original_card', sortable: true, class: 'text-center' },
        { key: 'deactivate_card_date', label: 'vehicle.deactivate_card_date', sortable: true, class: 'text-center' },
        { key: 'reactivate_card_date', label: 'vehicle.reactivate_card_date', sortable: true, class: 'text-center' },
        { key: 'issue_staff', label: 'vehicle.issue_staff', sortable: true, class: 'text-center' },
        { key: 'applied_service', label: 'vehicle.applied_service', sortable: true, class: 'text-center' },
        { key: "actions", label: "common.action", sortable: true },
      ],
      vehicle_items: [],
      paginatorItem: {
        commit_function: "GET_VEHICLE_LIST"
      },
      options: {
        format: "YYYY-MM-DD"
      },
      dateDisplayOptions: {
        format: "YYYY-MM-DD"
      },
      search: {
        code: "",
        apartment: "",
        vehicle_owner: "",
        vehicle_registration_name: "",
        vehicle_type: "",
        plate: "",
        branch: "",
        color: "",
        original_card: "",
        deactivate_card_date: "",
        reactivate_card_date: "",
        issue_staff: "",
        applied_service: ""
      },
      isLoading: false
    }
  },
  watch: {
    VEHICLE_LIST: function() {
      let vehicle_items = []
      this.VEHICLE_LIST.forEach( (vehicle, i) => {
        let id = vehicle.id
        let nonumber = (i + 1) + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let code = vehicle.code;
        let apartment = vehicle.apartment_details ? vehicle.apartment_details.apartment_code : null
        let vehicle_owner = vehicle.vehicle_owner_details ? `${vehicle.vehicle_owner_details.last_name} ${vehicle.vehicle_owner_details.first_name}` : null
        let vehicle_registration_name = vehicle.vehicle_registration_name
        let vehicle_type = vehicle.vehicle_type_details ? vehicle.vehicle_type_details.name : null
        let plate = vehicle.plate
        let branch = vehicle.branch
        let color = vehicle.color
        let isDriver = vehicle.isDriver
        let original_card = vehicle.original_card
        let deactivate_card_date = utils.formatSqlDate(vehicle.deactivate_card_date, null, this.dateDisplayOptions.format)
        let reactivate_card_date = utils.formatSqlDate(vehicle.reactivate_card_date, null, this.dateDisplayOptions.format)
        let applied_service = vehicle.service_details ? `${vehicle.service_details.name} - ${vehicle.service_details.fee_value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")} / tháng` : null
        let item = {
          id: id,
          nonumber: nonumber,
          code: code,
          apartment: apartment,
          vehicle_owner: vehicle_owner,
          vehicle_registration_name: vehicle_registration_name,
          vehicle_type: vehicle_type,
          plate: plate,
          branch: branch,
          color: color,
          isDriver: isDriver,
          original_card: original_card,
          deactivate_card_date: deactivate_card_date,
          reactivate_card_date: reactivate_card_date,
          applied_service: applied_service
        }
        vehicle_items.push(item)
      })
      this.vehicle_items = vehicle_items
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "VEHICLE_LIST"
    ])
  },
  methods: {
    ...mapActions([
      "GET_VEHICLE_LIST",
      "ADD_VEHICLE",
      "UPDATE_VEHICLE",
      "DELETE_VEHICLE",
      "GET_VEHICLE_TYPE_LIST"
    ]),
    onSearchVehicle: function() {
      const data = {
        params: {
          page: 1,
          code: this.search.code,
          apartment: this.search.apartment,
          vehicle_owner: this.search.vehicle_owner,
          vehicle_registration_name: this.search.vehicle_registration_name,
          vehicle_type: this.search.vehicle_type,
          plate: this.search.plate,
          branch: this.search.branch,
          color: this.search.color,
          original_card: this.search.original_card,
          deactivate_card_date: this.search.deactivate_card_date,
          reactivate_card_date: this.search.reactivate_card_date,
          issue_staff: this.search.issue_staff,
          applied_service: this.search.applied_service
        }
      }
      this.getVehicleList(data)
    },
    onOpenVehicleInput: function() {
      $(this.$refs[`modal-vehicle-input`]).modal("show")
    },
    onHideVehicleInput: function() {
      $(this.$refs[`modal-vehicle-input`]).modal("hide")
    },
    onOpenDeleteConfirm: function() {
      $(this.$refs[`modal-vehicle-delete`]).modal("show")
    },
    onHideDeleteConfirm: function() {
      $(this.$refs[`modal-vehicle-delete`]).modal("hide")
    },
    onOpenAddVehicle: function() {
      this.vehicle_data.id = 0
      this.onOpenVehicleInput()
    },
    onOpenEditVehicle: function(row) {
      this.vehicle_data.id = row.item.id
      this.onOpenVehicleInput()
    },
    onOpenDeleteVehicle: function(row) {
      this.vehicle_data.id = row.item.id
      this.onOpenDeleteConfirm()
    },
    onAddVehicle: function(saveVehicle) {
      const payload = {
        data: saveVehicle
      }
      this.ADD_VEHICLE(payload).then(
        function(res) {
          this.onHideVehicleInput()
          this.getVehicleList()
        }.bind(this)
      )
    },
    onSaveVehicle: function(id, saveVehicle) {
      const payload = {
        id: id,
        data: saveVehicle
      }
      this.UPDATE_VEHICLE(payload).then(
        function(res) {
          this.onHideVehicleInput()
          this.getVehicleList()
        }.bind(this)
      )
    },
    onDeleteVehicle: function(id) {
      const payload = {
        id: id
      }
      this.DELETE_VEHICLE(payload).then(
        function() {
          this.onHideDeleteConfirm()
          this.getVehicleList()
        }.bind(this)
      )
    },
    getVehicleList: function(data) {
      const payload = data || {
        params: {
          page: 1
        }
      }
      this.isLoading = true
      this.GET_VEHICLE_LIST(payload).then(
        function() {
          this.isLoading = false
        }.bind(this)
      )
    },
    onPagination: function(data) {
      this.getVehicleList(data)
    },
  },
  mounted() {
    this.getVehicleList()
    this.GET_VEHICLE_TYPE_LIST()
  },
  components: {
    "vehicle-input": VehicleInput,
    "lte-core-alert": LTECoreAlert,
    "confirm": Confirm,
    'paginator': Paginator,
    "date-picker": datePicker,
    "loading": Loading
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.row {
  margin-right: 0px;
  margin-left: 0px;
}

.extra-tools {
  float: left;
  margin-right: 10px;
}

</style>


// WEBPACK FOOTER //
// src/views/Apartment/VehicleBikeCar.vue